import { Component } from '@angular/core'

import { BaseComponent } from '../../shared'

interface IncidentInvestigationDashboardKpi {
    incidentsThisMonth: number
    incidentsYearToDate: number
    injuriesYearToDate: number
    nearMissesYearToDate: number
}

interface PeriodCount {
    label: string
    count: number
}

interface IncidentTypeCount {
    incidentType: string
    count: number
}

interface JobCount {
    jobNumber: string
    count: number
}

interface IncidentInvestigationDashboardMetrics {
    kpi: IncidentInvestigationDashboardKpi
    monthlyCounts: PeriodCount[]
    incidentTypeCounts: IncidentTypeCount[]
    topJobs: JobCount[]
}

const emptyMetrics = (): IncidentInvestigationDashboardMetrics => ({
    kpi: {
        incidentsThisMonth: 0,
        incidentsYearToDate: 0,
        injuriesYearToDate: 0,
        nearMissesYearToDate: 0,
    },
    monthlyCounts: [],
    incidentTypeCounts: [],
    topJobs: [],
})

@Component({
    selector: 'app-incident-investigation-dashboard',
    templateUrl: './incident-investigation-dashboard.component.html',
    styleUrls: ['./incident-investigation-dashboard.component.css'],
    standalone: true,
})
export class IncidentInvestigationDashboardComponent extends BaseComponent {
    metrics: IncidentInvestigationDashboardMetrics = emptyMetrics()
    metricsLoadError = false

    constructor() {
        super()
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            'incidentInvestigationDashboard',
            true,
            this.services.data
                .get<IncidentInvestigationDashboardMetrics>('/api/IncidentInvestigation/GetDashboardMetrics')
                .subscribe({
                    next: result => {
                        this.metrics = result ?? emptyMetrics()
                        this.metricsLoadError = false
                        this.initialLoadingComplete()
                    },
                    error: () => {
                        this.metrics = emptyMetrics()
                        this.metricsLoadError = true
                        this.initialLoadingComplete()
                    },
                }),
        )
    }

    maxMonthlyCount(): number {
        return Math.max(...this.metrics.monthlyCounts.map(m => m.count), 1)
    }

    maxTypeCount(): number {
        return Math.max(...this.metrics.incidentTypeCounts.map(t => t.count), 1)
    }
}
